import { render, staticRenderFns } from "./printReturnCode.vue?vue&type=template&id=0d4dac50&scoped=true"
import script from "./printReturnCode.vue?vue&type=script&lang=js"
export * from "./printReturnCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4dac50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d4dac50')) {
      api.createRecord('0d4dac50', component.options)
    } else {
      api.reload('0d4dac50', component.options)
    }
    module.hot.accept("./printReturnCode.vue?vue&type=template&id=0d4dac50&scoped=true", function () {
      api.rerender('0d4dac50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operatingPlatform/returnCodePrinting/component/printReturnCode.vue"
export default component.exports